import { BoxProps, Center, Flex, Spacer } from '@chakra-ui/react';
import React from 'react';

import {
  getContentBackgroundColor,
  getContentBackgroundGradient,
  getContentTextColor,
} from './hero.utils';
import HeroTitle from './HeroTitle';
import { HeroBackground, HeroContentPosition, HeroTitleVariant } from './index';

interface HeroContentProps {
  title?: {
    value: string | null | undefined;
    variant: HeroTitleVariant;
  };
  height: BoxProps['height'];
  overlay: boolean;
  background: HeroBackground;
  position: HeroContentPosition;
}

const HeroContent: React.FC<HeroContentProps> = ({
  children,
  title,
  height,
  position,
  overlay,
  background,
}) => {
  if (!children) {
    return null;
  }

  const backgroundColor = getContentBackgroundColor(background) || 'inherit';
  const backgroundGradient = getContentBackgroundGradient(background, position);
  const textColor = getContentTextColor(background);

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      minHeight={height}
      textColor={textColor}
      backgroundColor={
        overlay ? { base: backgroundColor, lg: 'unset' } : backgroundColor
      }
      bgGradient={overlay ? { lg: backgroundGradient } : undefined}
      paddingLeft={
        overlay && position === 'right' ? { base: 0, lg: '40%' } : undefined
      }
      paddingRight={
        overlay && position === 'left' ? { base: 0, lg: '40%' } : undefined
      }
    >
      {title?.value && (
        <>
          {title.variant !== 'accent' && <Spacer flexGrow={0.25} />}
          <HeroTitle
            position={position}
            variant={title.variant}
            color={textColor}
          >
            {title.value}
          </HeroTitle>
        </>
      )}
      <Spacer flexGrow={title?.variant === 'accent' ? undefined : 0.25} />
      <Center
        sx={{
          flex: 1,
          padding: 0,
          width: 'full',
          h1: {
            marginBlockEnd: '16px',
          },
          h2: {
            marginBlockEnd: '14px',
          },
          h3: {
            marginBlockEnd: '12px',
          },
          h4: {
            marginBlockEnd: '8px',
          },
          h5: {
            marginBlockEnd: '4px',
          },
          h6: {
            marginBlockEnd: 0,
          },
        }}
      >
        {children}
      </Center>
      <Spacer />
    </Flex>
  );
};

export default HeroContent;
